.complaint {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.row {
  display: flex;
  align-items: baseline;
  margin-bottom: 12px;
}

.label {
  width: 180px;
  margin-right: 8px;
  color: var(--fg-secondary);
  flex-shrink: 0;
}

.offerId {
  text-decoration: none;
  pointer-events: none;
}
